import React, { useEffect, useState } from "react";
import axios from "axios";
import { Grid } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { cardLinkIcon, clickedIcon } from "../assets";
import NavigationBar from "./NavigationBar";
import SearchItems from "./SearchItems";
import Pegination from "./Pegination";

function Cards() {
  const location = useLocation();
  const [allData, setAllData] = useState([]);
  const [visibleCards, setVisibleCards] = useState(27);
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    axios
      .get("https://devuse-fullstack.vercel.app/tools/all-tools")
      .then((response) => {
        const combinedData = response.data;
        const shuffledData = shuffleArray(combinedData);
        setAllData(shuffledData);
        setFilteredData(shuffledData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const cardLoading = Array(visibleCards).fill(true);

  const shuffleArray = (array) => {
    const newArray = [...array];
    const newTools = newArray.filter((item) => item.toolType).reverse();
    const otherCards = newArray.filter((item) => !item.toolType);
    const shuffledOtherCards = shuffleArrayHelper(otherCards);
    const shuffledArray = [...newTools, ...shuffledOtherCards];

    return shuffledArray;
  };

  const shuffleArrayHelper = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  const handleToolClick = (toolId) => {
    axios
      .post(`https://devuse-fullstack.vercel.app/tools/click/${toolId}`)
      .then((response) => {
        axios
          .get("https://devuse-fullstack.vercel.app/tools/all-tools")
          .then((response) => {
            const combinedData = response.data;
            const shuffledData = shuffleArray(combinedData);
            setAllData(shuffledData);
            setFilteredData(shuffledData);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      })
      .catch((error) => {
        console.error("Error updating click count:", error);
      });
  };

  const routesToHideComponents = [
    "/samieullahbaig",
    "/dashboard",
    "/add-tool",
    ...allData.map((item) => `/dashboard/tool/edit/${item._id}`),
  ];

  const shouldHideComponents = routesToHideComponents.includes(
    location.pathname
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSearchClick = () => {
    setShowSearch(!showSearch);
  };

  const handleSearchChange = (text) => {
    setSearchText(text);
    const filteredData = allData.filter(
      (item) =>
        item.toolTitle.toLowerCase().includes(text.toLowerCase()) ||
        item.toolDescription.toLowerCase().includes(text.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  const handleLoadMore = () => {
    setVisibleCards(visibleCards + 6);
  };

  return (
    <div>
      {!shouldHideComponents && (
        <NavigationBar
          showSearch={showSearch}
          onSearchClick={handleSearchClick}
        />
      )}
      {isMobile && !shouldHideComponents && (
        <Pegination showSearch={showSearch} onSearchClick={handleSearchClick} />
      )}
      {showSearch && (
        <SearchItems
          onSearchChange={handleSearchChange}
          searchText={searchText}
        />
      )}
      <Grid container justifyContent={"center"} gap={2} mt={2}>
        {filteredData.length === 0 &&
          allData.length === 0 &&
          cardLoading.map((_, index) => (
            <Grid xs={10} sm={6} md={4} lg={3} key={index}>
              <div className="card_loader" />
            </Grid>
          ))}
        {filteredData.length === 0 && allData.length > 0 ? (
          <Grid item xs={12} align="center">
            <h1 className="not-found-text">No results found</h1>
          </Grid>
        ) : (
          filteredData.slice(0, visibleCards).map((item, index) => (
            <Grid xs={10} sm={4.9} md={4.2} lg={3} key={index}>
              <div className="card" key={index}>
                <div className="card_img_container">
                  <img src={item.backgroundImageUrl} alt="tools" />
                </div>
                <div className="card_content_container">
                  <div className="tag">
                    <Link
                      to={`/${item.toolTag.replace(/\s+/g, "-")}/tools`}
                      className="tag_width"
                    >
                      <span>{item.toolTag}</span>
                    </Link>
                    {item.toolType && (
                      <div className="tool-version">{item.toolType}</div>
                    )}
                    <div className="like_analytics">
                      <span>{item.clicks}</span>
                      <img src={clickedIcon} alt="card click indicator" />
                    </div>
                  </div>
                  <a
                    href={item.toolLink}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => handleToolClick(item._id)}
                  >
                    <div className="card_link_container">
                      <h1>{item.toolTitle}</h1>
                      <img
                        src={cardLinkIcon}
                        className="link_image"
                        alt="link-icon"
                      />
                    </div>
                  </a>
                  <p>{item.toolDescription}</p>
                </div>
              </div>
            </Grid>
          ))
        )}
        {visibleCards < filteredData.length && (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            mt={5}
            sx={{ mb: { xs: 4, md: 0 } }}
          >
            <Grid
              item
              xs={12}
              md={9}
              lg={9}
              mt={5}
              className="postion-relative"
            >
              <button onClick={handleLoadMore}>
                <p></p>
                <svg
                  strokeWidth="4"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  ></path>
                </svg>
              </button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default Cards;
